import React from "react";
import { Switch, Route, NavLink } from "react-router-dom";
import { Panel } from "@culturehq/components";

import { useProfile } from "app/context";
import { t } from "app/utils";

import SlackIntegration from "./integrations/SlackIntegration";
import MicrosoftIntegration from "./integrations/MicrosoftIntegration";
import GoogleIntegration from "./integrations/GoogleIntegration";
import SocialIntegrations from "./integrations/SocialIntegrations";

const NavTab = ({ to, phrase }) => (
  <li role="navigation">
    <NavLink to={to} exact activeClassName="active">{phrase}</NavLink>
  </li>
);

const Integrations = () => {
  const { profile } = useProfile();

  return (
    <Panel limitWidth>
      <ul className="nav nav-tabs">
        <NavTab to="/admin/slack" phrase={t("Slack")} />
        <NavTab to="/admin/microsoft" phrase={t("Microsoft")} />
        <NavTab to="/admin/google" phrase={t("Google")} />
        <NavTab to="/admin/social" phrase={t("Social")} />
      </ul>
      <Panel.Body>
        <Switch>
          <Route exact path="/admin/slack" component={SlackIntegration} />
          <Route exact path="/admin/microsoft" component={MicrosoftIntegration} />
          <Route exact path="/admin/google" component={GoogleIntegration} />
          <Route exact path="/admin/social" component={SocialIntegrations} />
        </Switch>
      </Panel.Body>
    </Panel>
  );
};

export default Integrations;
